module.exports = __webpack_public_path__ + "static/media/7869C.68daa982.jpg";